import { handleApiResponse } from 'src/_helpers/handleApiResponse'

export const fetchApi = (url, method = 'GET', headers = {}, request = {}, handleResponse = null) => {
  return fetch(process.env.NEXT_PUBLIC_API_ENTRYPOINT + url, {
    method,
    headers: {
      accept: 'application/ld+json',
      ...headers,
    },
    ...request,
  }).then(handleResponse || handleApiResponse)
}
